export const DEFAULT_REQUEST_OPTIONS_TIMEOUT = 5000
export const DEFAULT_CMS_TIMEOUT = 10000
export const HSRP_LOADER_TIMEOUT = 3000
export const MOTOR_ORCHESTOR_FETCH_TIMEOUT = 1500
